import { toast } from "react-toastify";
import { SearchParams, SearchParams1 } from "../../assets/interfaces/FX_POS_Interfaces";
import HelperService from "../../Services/HelperService";
import WebService from "../../Services/WebService";
const apiLockMap = new Map<string, boolean>();
export const GetListCommonCall = (end_point: string, params?: SearchParams | SearchParams1, btnId?: string) => {
    let queryString = "";
    if (params)
        queryString = HelperService.toQueryString(params);
    let action = queryString ? `${end_point}?${queryString}` : `${end_point}`
    return WebService.getAPI({
        action: action,
        body: null,
        btnId: btnId ? btnId : "",
    }).then((res: any) => {
        return res;
    }).catch((error: any) => {
        return error;
    });
}
export const GetInfoCommonAPI = (api_end: string, btnId?: string) => {
    if (!api_end) return Promise.resolve(null);
    return WebService.getAPI({
        action: `${api_end}`,
        body: null,
        btnId: btnId ? btnId : "",
    }).then((res: any) => {
        return res?.info;
    }).catch((error: any) => {
        return error
    });
}
export const PostCommonAPI = (obj: any, api_end: string, btnId: string, isHideToast?: boolean) => {
    return WebService.postAPI({
        action: `${api_end}`,
        body: obj,
        btnId: `${btnId}`,
        isHideToast: isHideToast
    }).then((res: any) => {
        return res;
    }).catch((err: any) => {
        return err;
    })
}

//One API call per request signature
// export const PostCommonAPI = async (
//     obj: any,
//     api_end: string,
//     btnId: string,
//     isHideToast?: boolean
// ) => {
//     const lockKey = `${api_end}_${JSON.stringify(obj)}`;
//     // if (apiLock 
//     // apiLockMap.set(lockKey, true);
//     try {
//         const res: any = await WebService.postAPI({
//             action: api_end,
//             body: obj,
//             btnId,
//             isHideToast
//         });
//         // apiLockMap.delete(lockKey);
//         return res;
//     } catch (err) {
//         throw err;
//     } finally {
//         // apiLockMap.delete(lockKey);
//     }
// };

export const PutCommonAPI = (obj: any, api_end: string, btnId: string, isHideToast?: boolean) => {
    return WebService.putAPI({
        action: `${api_end}`,
        body: obj,
        btnId: `${btnId}`,
        isHideToast: isHideToast
    }).then((res: any) => {
        if (res.status) {
            return res
        }
        else return null
    }).catch((err: any) => {
        return null;
    })
}
export const handleUploadFile = (file: any, api_end: string, btn_id?: string) => {
    return WebService.uploadAPI({
        action: `${api_end}`,
        _file: file,
        key: "file",
        btnId: btn_id
    })
        .then((res: any) => {
            if (!res.status) {
                toast.error(res.message)
            }
        })
        .catch((error: any) => {
            toast.error(error?.response?.data?.message);
            return error;
        })
        .finally(() => {
        });
}

export const DeleteCommonAPI = (api_end: string, btnId: string) => {
    return WebService.deleteAPI({
        action: `${api_end}`,
        btnId: `${btnId}`,
    }).then((res: any) => {
        toast.success(res.message)
    }).catch((err: any) => {

    })
}

export const CommonFormDataPutCall = (body: any, api_end: string, btnId: string) => {
    return WebService.formaDataPutAPI({
        action: `${api_end}`,
        body: body,
        btnId: `${btnId}`
    }).then((res: any) => {
        return res;
    }).catch((err: any) => {

    });
}

export const CommonFormDataPostCall = (body: any, api_end: string, btnId: string) => {
    return WebService.formaDataPostAPI({
        action: `${api_end}`,
        body: body,
        btnId: `${btnId}`
    }).then((res: any) => {
        return res;
    }).catch((err: any) => {

    });
}